<template>
  <div class="product-item">
    <div class="product-head clearfix">
      <img
        class="f-left"
        :src="productBase.icon"
        alt
      />
      <div class="f-left">
        <p class="title">{{ productBase.title }}</p>
        <slot name="desc"></slot>
      </div>
      <div class="f-left ml-15" v-if="coupon.enable">
        <span class="des coupon-bg" @click="onCouponShow">
          <span class="coupon-tips">优惠券</span>
          <span class="coupon-count">(<b>{{ coupon.total }}</b>张可用)</span>
        </span>
      </div>
      <div class="f-left ml-15" v-if="coupon.enable">
        <span class="couponChooseInfo" v-show="coupon.value.couponNumber">(已选择优惠券<b>{{ coupon.value.couponNumber }}</b>)</span>
      </div>
      <div
        class="f-right extra"
      >
        <span class="selected-product">{{ value | total(selectType, coupon) }}</span>
        <div
          class="arrow-wrapper"
          @click="toggle = !toggle"
        >
          <a-icon :type="`${ toggle ? 'down' : 'up' }-circle`" :style="{ fontSize: '30px', color: '#ccc' }"/>
        </div>
      </div>
    </div>
    <div
      :class="['product-main', `${productBase.className}-group-wrapper`]"
      v-show="toggle"
    >
      <a-radio-group v-if="!multiple && !complex" :value="value ? value.offerItemId : ''" :disabled="hasMustSelect(products)">
        <a-row :class="['product-main--row', `${productBase.className}-group`, 'clearfix']" :gutter="[30, 20]">
          <a-col
            v-for="(product, idx) in products"
            :key="idx"
            :span="productBase.span"
          >
            <div :class="['product-main--col', `${productBase.className}-wrapper`]">
              <slot name="product" v-bind:product="product" v-bind:index="idx"></slot>
              <div class="des">
                <span>{{ product.services[0].productName | productName(type) }}</span>
                <div class="f-right">
                  <span class="f-left">{{ getNetFareAmountFromUtil(product.services[0].fareDetails) }}元</span>
                  <a-radio
                    class="box"
                    @click="onSelect(product.services[0])"
                    :value="product.services[0].offerItemId"
                  ></a-radio>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-radio-group>
      <a-checkbox-group
        v-else-if="multiple && !complex"
        :value="value"
        @change="onGroupChange"
      >
      <a-row :class="['product-main--row', `${productBase.className}-group`, 'clearfix']" :gutter="[30, 20]">
          <a-col
            v-for="(product, idx) in products"
            :key="idx"
            :span="productBase.span"
          >
            <div :class="['product-main--col', `${productBase.className}-wrapper`]">
              <slot name="product" v-bind:product="product" v-bind:index="idx"></slot>
              <div class="des">
                <span>{{ product.services[0].productName | productName }}</span>
                <div class="f-right">
                  <span class="f-left">{{ getNetFareAmountFromUtil(product.services[0].fareDetails) }}元</span>
                  <a-checkbox
                    class="box"
                    :value="product.services[0]"
                    :disabled="product.services[0].mustSelect"
                  ></a-checkbox>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <div v-else >
        <a-row :class="['product-main--row', `${productBase.className}-group`, 'clearfix']" :gutter="[30, 20]">
          <a-col
            v-for="(product, idx) in products"
            :key="idx"
            :span="productBase.span"
          >
            <div :class="['product-main--col', `${productBase.className}-wrapper`]">
              <slot name="product" v-bind:product="product" v-bind:index="idx"></slot>
              <div class="des">
                <div class="flex-hb-vc">
                  <span class="product-name" style="max-width: 220px" :title="product.services[0].productName | productName">{{ product.services[0].productName | productName }}</span>
                  <span>{{ getNetFareAmountFromUtil(product.services[0].fareDetails) }}元</span>
                </div>
                <div class="f-right clearfix">
                  <!-- <a-input-number class="product-input-number"
                    @change="onNumberChange($event, product.services[0])"
                    :value="getNumber(product.services[0], value)"
                    :defaultValue="0"
                    :min="0"
                    :max="10"
                    :disabled="product.services[0].mustSelect"
                   /> -->
                   <div class="product-input-number f-right">
                    <button class="number-button reduce-number-button" @click="onNumberChange(getNumber(product.services[0], value) - 1, product.services[0])" :disabled="getNumber(product.services[0], value) === 0">
                      <a-icon type="minus" :style="{ fontSize: '12px', color: '#ccc' }" />
                    </button>
                    <input class="number-input" type="text" :value="getNumber(product.services[0], value)" :disabled="product.services[0].mustSelect" readonly>
                    <button class="number-button add-number-button" @click="onNumberChange(getNumber(product.services[0], value) + 1, product.services[0])" :disabled="getNumber(product.services[0], value) === 10">
                      <a-icon type="plus" :style="{ fontSize: '12px', color: '#ccc' }" />
                    </button>
                   </div>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import { isEqual, differenceWith, assignIn, cloneDeep, debounce } from 'lodash'
import { getNetFareAmount } from '@/assets/js/util'
import { headMap } from '../config'
import Observer from '@/assets/js/observer'

const mainSettings = window.__MICRO_ROOT__ ?? {}

export default {
  data () {
    return {
      toggle: true
    }
  },
  props: {
    type: {
      type: String,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    value: [Object, Array],
    coupon: {
      type: Object,
      default: function () {
        return {
          total: 0,
          value: {},
          enable: false
        }
      }
    },
    insuranceDes: [Object, Array],
    productBase: [Object, Array]
  },
  computed: {
    multiple () {
      const { value } = this

      return Array.isArray(value)
    },
    complex () {
      const { products } = this

      return products.find(product => { return product.services[0].isComplex })
    },
    className () {
      return headMap[this.type].className
    },
    span () {
      return headMap[this.type].span
    },
    selectType () {
      const { multiple, complex } = this
      const selectTypes = ['radio', 'multiple', 'complex']
      return complex ? selectTypes[2] : (multiple ? selectTypes[1] : selectTypes[0])
    }
  },
  methods: {
    onCouponShow () {
      this.$emit('showCoupon', this.type, true)
    },
    onNumberChange: debounce(function (num, value) {
      const { type, value: oldValues = [] } = this
      const newValue = { ...value, productNum: num }
      const newValues = cloneDeep(oldValues)
      let isAdd = true
      const cartValue = {
        offerItemType: value.serviceType,
        detail: {
          offerItemId: value.offerItemId,
          productCode: value.productCode,
          productName: value.productName,
          price: getNetFareAmount(value.fareDetails),
          count: 1
        }
      }
      if (oldValues.length > 0) {
        const index = oldValues.findIndex(oldValue => { return oldValue.offerItemId === newValue.offerItemId })
        if (index > -1) {
          if (newValue.productNum < oldValues[index].productNum) {
            isAdd = false
          }
          if (newValue.productNum) {
            newValues[index] = newValue
          } else {
            newValues.splice(index, 1)
          }
        } else {
          newValues.push(newValue)
        }
      } else {
        newValues.push(newValue)
      }
      this.$nextTick(() => {
        this.$emit('select', type, newValues, isAdd, cartValue, false)
      })
    }, 400),
    // 多选
    onGroupChange (value) {
      const { type, value: oldValues = [] } = this
      const isAdd = oldValues.length < value.length
      // 多选，跟原值比较，确定是删除还是增加
      const oldValue = isAdd ? differenceWith(value, oldValues, isEqual)[0] : differenceWith(oldValues, value, isEqual)[0]

      const observer = new Observer()
      observer.complete = () => {
        this.onGroupChangeSuccess(value, oldValue, isAdd, type)
      }

      if (!isAdd) {
        // NOTE: 首航保险取消提示
        if (mainSettings.airline === 'JD' && ['lugInsurance', 'insurance'].includes(type)) {
          const { insuranceDes } = this
          const { cancelContent } = insuranceDes?.[oldValue?.productName] ?? ''
          observer.add(() => {
            return new Promise((resolve, reject) => {
              this.$confirm({
                title: '温馨提示',
                width: 400,
                content: cancelContent,
                okText: '确认',
                cancelText: '取消保险',
                onOk: () => {
                  reject(new Error())
                },
                onCancel: () => {
                  resolve()
                }
              })
            })
          })
        }
      }

      if (observer.queue.length) {
        observer.start()
      } else {
        this.onGroupChangeSuccess(value, oldValue, isAdd, type)
      }
    },
    onGroupChangeSuccess (value, oldValue, isAdd, type) {
      const cartValue = {
        offerItemType: oldValue.serviceType,
        detail: {
          offerItemId: oldValue.offerItemId,
          productCode: oldValue.productCode,
          productName: oldValue.productName,
          price: getNetFareAmount(oldValue.fareDetails),
          count: 1
        }
      }

      this.$emit('select', type, value, isAdd, cartValue, false)
    },
    // 单选
    onSelect (value) {
      const { type, value: oldValue } = this
      const isAdd = !isEqual(value ? value.offerItemId : {}, oldValue ? oldValue.offerItemId : {})

      const observer = new Observer()
      observer.complete = () => {
        this.onSelectSuccess(value, oldValue, isAdd, type)
      }

      if (!isAdd) {
        // NOTE: 首航保险取消提示
        if (mainSettings.airline === 'JD' && ['lugInsurance', 'insurance'].includes(type)) {
          const { insuranceDes } = this
          const { cancelContent } = insuranceDes?.[oldValue?.productName] ?? ''
          observer.add(() => {
            return new Promise((resolve, reject) => {
              this.$confirm({
                title: '温馨提示',
                width: 400,
                content: cancelContent,
                okText: '确认',
                cancelText: '取消保险',
                onOk: () => {
                  reject(new Error())
                },
                onCancel: () => {
                  resolve()
                }
              })
            })
          })
        }
      }

      if (observer.queue.length) {
        observer.start()
      } else {
        this.onSelectSuccess(value, oldValue, isAdd, type)
      }
    },
    onSelectSuccess (value, oldValue, isAdd, type) {
      if (oldValue) {
        // 有旧值，先移除
        this.$emit('select', type, [], false, {
          offerItemType: oldValue.serviceType,
          detail: {
            offerItemId: oldValue.offerItemId,
            productCode: oldValue.productCode,
            productName: oldValue.productName,
            price: getNetFareAmount(oldValue.fareDetails),
            count: 1
          }
        }, this.coupon.enable)
      }

      if (isAdd) {
        this.$emit('select', type, [assignIn({}, value)], true, {
          offerItemType: value.serviceType,
          detail: {
            offerItemId: value.offerItemId,
            productCode: value.productCode,
            productName: value.productName,
            price: getNetFareAmount(value.fareDetails),
            count: 1
          }
        }, this.coupon.enable)
      }
    },
    // 单选如果服务有必选项时，diabled radioGroup
    hasMustSelect (products) {
      let flag = false

      for (let i = 0, len = products.length; i < len; i++) {
        if (products[i].services[0].mustSelect) {
          flag = true
          break
        }
      }

      return flag
    },
    getNetFareAmountFromUtil (value) {
      return getNetFareAmount(value)
    },
    getNumber (product, values = []) {
      return values.find(value => { return value.offerItemId === product.offerItemId })?.productNum ?? 0
    }
  },
  filters: {
    // title (value) {
    //   return value ? this.productBase?.[value]?.title : ''
    // },
    // icon (value) {
    //   return value ? this.productBase?.[value]?.icon : ''
    // },
    total (value, selectType, coupon) {
      if (!value || (selectType === 'multiple' && !value.length) || (selectType === 'complex' && value.findIndex(item => { return item.productNum !== 0 }) < 0)) {
        return ''
      }
      let fare = ''
      if (selectType === 'complex') {
        let price = 0
        const title = value.map(item => {
          price += parseFloat(getNetFareAmount(item.fareDetails)) * item.productNum
          return `${item.productName} * ${item.productNum}`
        }).join(', ')

        fare = `${title} ${price}元`
      } else if (selectType === 'multiple') {
        let price = 0
        const title = value.map(item => {
          price += parseFloat(getNetFareAmount(item.fareDetails))
          return item.productName
        }).join(', ')

        fare = `${title} ${price}元`
      } else {
        fare = `${value.productName} ${getNetFareAmount(value.fareDetails)}元`
      }

      if (coupon.value.couponAmount) {
        return `${fare} -${Math.min(coupon.value.couponAmount, getNetFareAmount(value.fareDetails))}元`
      }

      return fare
    },
    productName (value, type) {
      return value + (type === 'luggage' ? '行李' : '')
    }
  }
}
</script>
<style lang="less">
.filterGary {
  filter: grayscale(1);
}
</style>
